import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Souscripteur } from '../models/souscripteur.model';
import { Observable } from 'rxjs/Observable';
import Api from '../../common/services/api.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class SouscripteurService {
    private endpoint = 'souscripteursonly';
    //private serviceUrl = 'http://192.168.1.107:8000/sonavie/souscripteursonly'; 
    constructor(private http: HttpClient, private api: Api) { }
    getSouscripteur(): Observable<Souscripteur[]> {
         return this.api.get(this.endpoint);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin-app/services/souscripteur.service.ts